import { ReactComponent as BoldIcon } from 'assets/icons/bold24.svg'
import cx from 'classnames'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useBoldToggle } from 'common/Prose/Toolbar/hooks/useBoldToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { observer } from 'mobx-react-lite'
import Styles from '../../MobileToolbar.module.scss'

export const BoldMark = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active, handleClick, disabled } = useBoldToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Set bold"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active,
        [Styles.disabled]: disabled,
      })}
      onPress={handleClick}
      data-testid="mobile-toolbar-bold-mark"
      {...props}
    >
      <BoldIcon />
    </Button>
  )
})
